import { useEffect, useState } from 'react';
import ReportFilter from '../../components/reportFilter';
import { useReportContext } from '../../components/reportContext';
import { useGetAdminAssessmentReportValuesMutation, useUpdateAdminAssessmentReportValuesMutation,
  useGetAssignmentReportValuesMutation, useUpdateAssignmentReportValuesMutation
} from '../../../../features/authentication/persistApiSlice';
import CustomToast from '../../../../components/Toast';
import { useNavigate } from 'react-router';

const AllAssignmentsReport = () => {
  const navigate = useNavigate();
  const { assignmentId, setAssignmentId, selectedClassId, setSelectedClassId, selectedStudentId,  
    selectedCourseId, setSelectedCourseId, startDate, setStartDate, endDate, setEndDate, isAllReport, setIsAllReport, 
    studentToIncludeTab, setStudentToIncludeTab, scoreTypeTab, setIsAssessment, setReportType, setSelectedStudentId, setSelectedClassIds } = useReportContext();

  const [getAssessmentReportValues] = useGetAdminAssessmentReportValuesMutation();
  const [updateAssessmentReportValues] = useUpdateAdminAssessmentReportValuesMutation();
  const [getAssignmentReportValues] = useGetAssignmentReportValuesMutation();
  const [updateAssignmentReportValues] = useUpdateAssignmentReportValuesMutation();

  const [reportTitle, setReportTitle] = useState('');
  const [reportInfo, setReportInfo] = useState('');
  const [reportName, setReportName] = useState('');
  const [persistValueLoaded, setPersistValueLoaded] = useState(false);

  const reportType = window.location.href.split('/').pop();

  const handleCreateReport = () => {
    if(studentToIncludeTab == 2 && selectedStudentId == 0){
      CustomToast('Please select a student to create report.','error');
      return;
    }

    if(reportType === 'all-admin-assessments')
      UpdateAssessmentPersistData();
    else
      UpdateAssignmentPersistData();
    handleReportNavigation();
  };

  useEffect(() => {
    getReportDetails();
    setIsAllReport(true);
  }, []);

  const getReportDetails =()=>{
    if (reportType === 'all-admin-assessments') {
      setReportType('all-admin-assessments');
      setIsAssessment(true);
      setReportName('All Assessments');
      setReportTitle('All Admin Assessments Report');
      setReportInfo('The All Admin Assessments Report shows student performance for published assessments, providing a breakdown by various categories.');
      getAssessmentPersistData();
    }
    else if(reportType === 'all-assignments')
    {
      setReportType('all-assignments');
      setIsAssessment(false);
      setReportName('All Assignments');
      setReportTitle('All Assignments Report');
      setReportInfo('The All Assignments Report shows student performance for individual assignments or for all assignments in a course (currently assigned and unassigned), providing a breakdown by various categories.');
      getAssignmentPersistData();
    }
  };

  const getAssignmentPersistData = async() =>
  {
    var persistData =await getAssignmentReportValues().unwrap();
    setSelectedCourseId(persistData.courseId);
    setSelectedClassId(persistData.classId);
    setSelectedStudentId(persistData.studentId);
    setStartDate(persistData.startDate);
    setEndDate(persistData.endDate);
    setAssignmentId(persistData.assignmentId);
    setStudentToIncludeTab(persistData.studentToInclude);
    setSelectedClassIds(persistData.studentToInclude == 0 ? [-2] : persistData.studentToInclude == 1 ? [] : [-1]);
    setPersistValueLoaded(true);
  };

  const UpdateAssignmentPersistData = async() => {
    var options={
      'courseId': selectedCourseId,
      'isAllReport': isAllReport,
      'assignmentId': assignmentId,
      'startDate': startDate,
      'endDate': endDate,
      'studentToInclude': studentToIncludeTab,
      'studentId': selectedStudentId,
      'classId': selectedClassId
    };
    await updateAssignmentReportValues(options);
  };

  const getAssessmentPersistData = async() =>
  {
    var persistData = await getAssessmentReportValues().unwrap();
    setSelectedCourseId(persistData.courseId);
    setSelectedClassId(persistData.classId);
    setStartDate(persistData.startDate);
    setEndDate(persistData.endDate);
    setAssignmentId(persistData.assignmentId);
    setStudentToIncludeTab(persistData.studentToInclude);
    setPersistValueLoaded(true);
  };
  
  const UpdateAssessmentPersistData = async() => {
    var options={
      'courseId': selectedCourseId,
      'isAllReport': isAllReport,
      'assignmentId': assignmentId,
      'startDate': startDate,
      'endDate': endDate,
      'studentToInclude': studentToIncludeTab,
      'studentId': selectedStudentId,
      'classId': selectedClassId
    };
    await updateAssessmentReportValues(options);
  };

  const handleReportNavigation = async() => {
    if(scoreTypeTab == 0)
    {
      switch(studentToIncludeTab) {
      case 0:
        setSelectedClassId(-2);
        navigate('all_students_score_info');
        break;
      case 1:
        navigate('all_students_score_info');
        break;
      case 2:
        navigate('single_student_score_info');
        break;
      }
    }else if(scoreTypeTab == 1) {
      navigate(`0/class_cumulative_report?studentsToInclude=${studentToIncludeTab}`);
    }
  };

  return (
    <>
      {persistValueLoaded &&
        <ReportFilter 
          handleCreateReport={handleCreateReport} 
          isTOTReport={false} 
          backOnClick={() => window.history.back()} 
          description={reportInfo}
          type={reportName}
          title={reportTitle}
        />
      }</>
    
  );
};

export default AllAssignmentsReport;